import { useEffect, useState } from "react";

import "../../assets/scss/Viewmode.scss";
import Axios from "axios";
import DownloadModal from "../../components/DownloadModal";

import { ReactComponent as Link } from "../../assets/icons/normal/link.svg";
import { ReactComponent as LinkCopy } from "../../assets/icons/normal/linkcopy.svg";
import topbtn from "../../assets/icons/normal/topbtn.svg";
import updateIcon from "../../assets/icons/normal/updateIcon.svg";
import ToastMessage from "../../components/ToastMessage";
import { TempleBuddhist } from "@mui/icons-material";

const ViewMode = (props: any) => {
  const mode = process.env.REACT_APP_MODE === "app";

  const [onDrag, setOnDrag] = useState(false);
  const [dragStart, setDragStart] = useState(-1);
  const [dragEnd, setDragEnd] = useState(-1);

  const [checked, setChecked] = useState<number[]>([]);
  const [modal, setModal] = useState(false);
  const [downloadInfo, setDownloadInfo] = useState({
    progress: 0,
    completed: false,
    total: 0,
    loaded: 0,
    imgCount: 0,
    curCount: 0,
  });
  const [imgTitle, setImgTitle] = useState("");
  const [hover, isHover] = useState(false);

  const handleToggle = (value: number) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const alphaValue = (alpha: number): number => {
    const value: any = {
      40: 1,
      50: 2,
      60: 3,
      70: 4,
      80: 5,
    };
    return value[alpha] ?? 0;
  };

  const dateStringCutter = (value: string) => {
    var hours = Number(value.slice(11, 13));
    var ampm = hours >= 12 ? "오후" : "오전";
    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${value.slice(0, 4)}.${value.slice(5, 7)}.${value.slice(8, 10)}`;
  };

  const modalHandler = () => {
    setModal(false);
    setDownloadInfo({
      progress: 0,
      loaded: 0,
      total: 0,
      completed: false,
      imgCount: 0,
      curCount: 0,
    });
  };

  const handleListMouseDown = (e: any, index: number) => {
    setOnDrag(true);
    setDragStart(index);
  };
  const handleListMouseUp = () => {
    setOnDrag(false);
  };

  const handleListMouseEnter = (e: MouseEvent, index: number) => {
    setDragEnd(index);
    const totalHeight = window.innerHeight;
    if (totalHeight - e.clientY < 120) {
      setTimeout(() => {
        if (onDrag) {
          const scrollTemp = document.getElementById("view-scroller");
          if (scrollTemp) {
            scrollTemp.scrollTo({ top: scrollTemp.scrollTop + 100 });
          }
        }
      }, 500);
    }
  };

  const copyToClipboard = (url: string) => {
    const tmp = document.createElement("input");
    document.body.appendChild(tmp);
    tmp.value = url;
    tmp.select();
    document.execCommand("copy");
    document.body.removeChild(tmp);
    props.setToastState(true);
  };

  const openNewWindow = (url: string) => {
    const windowFeature = "width=1440, height=1024";
    window.open(url, "_blank", windowFeature);
  };

  useEffect(() => {
    window.addEventListener("mouseup", handleListMouseUp);

    return () => {
      window.removeEventListener("mouseup", handleListMouseUp);
    };
  }, []);

  useEffect(() => {
    if (dragStart !== dragEnd && dragStart !== -1 && dragEnd !== -1 && onDrag) {
      props.handleDragCheckImage(dragStart, dragEnd);
    } else if (dragStart === dragEnd && dragStart !== -1 && onDrag) {
      props.handleCheckImage(dragStart);
    }
  }, [dragStart, dragEnd, onDrag]);

  const imgSize = (sourceImage: string) => {
    let image = new Image();
    image.src = sourceImage;
    return [image.naturalWidth, image.naturalHeight];
  };

  return (
    <div className="wrapper">
      <div className="viewColumn">
        <div className="viewColumn-num">
          <span>번호</span>
        </div>
        <div className="viewColumn-img">
          <span>이미지</span>
        </div>
        <div className="viewColumn-title">
          <span>제목</span>
        </div>
        <div className="viewColumn-date">
          <span>생성일</span>
        </div>
        <div className="viewColumn-type">
          <span>종류</span>
        </div>
        <div className="viewColumn-size">
          <span>규격</span>
        </div>
        <div className="viewColumn-alpha">
          <span>기술 세기</span>
        </div>
        <div className="viewColumn-link">
          <span>링크 열기</span>
        </div>
        <div className="viewColumn-copy">
          <span>링크 복사</span>
        </div>
      </div>

      {modal && (
        <DownloadModal
          title={imgTitle}
          downloadInfo={downloadInfo}
          modalHandler={modalHandler}
          setStopDownload={props.setStopDownload}
        />
      )}

      <div className="viewdata" id="list-scroller">
        {props.data?.map((item: any, index: number) => (
          <div
            className={
              props.isChecked[index]
                ? "viewdata-wrapper selected"
                : "viewdata-wrapper"
            }
            key={item.id}
            // onClick={() => handleCheckImage(index)}
            onMouseEnter={(e: any) => handleListMouseEnter(e, index)}
            // onMouseUp={(e: any) => handleListMouseUp(e, index)}
            onMouseDown={(e: any) => handleListMouseDown(e, index)}
          >
            <div className="viewdata-num">
              <span aria-disabled>{index + 1}</span>
            </div>
            <div className="viewdata-img">
              <img
                src={item?.resizedSourceImage || item?.sourceImageUrl}
                alt={`card-image_${item?.id}`}
              />
              <div
                className="viewdata-img-hover"
                onClick={() =>
                  props.handleClickNormal(
                    item.id,
                    item.sourceImageUrl,
                    false,
                    item.width,
                    item.height,
                    item.title,
                    item.channel,
                    item.colorSpace,
                    item.url,
                    item.alpha,
                    "thumbnail"
                  )
                }
              >
                <img src={updateIcon} />
              </div>
            </div>
            <div className="viewdata-title">
              <span>{item.title}</span>
            </div>
            <div className="viewdata-date">
              <span>{dateStringCutter(item.created)}</span>
            </div>
            <div className="viewdata-type">
              <span>{item?.fileFormat} 이미지</span>
            </div>
            <div className="viewdata-size">
              <span>
                {imgSize(item.sourceImageUrl)[0]} x
                {imgSize(item.sourceImageUrl)[1]}
              </span>
            </div>
            <div className="viewdata-alpha">
              <span>
                {alphaValue(item.alpha) ? alphaValue(item.alpha) : "-"}
              </span>
            </div>
            <div className="viewdata-link">
              <button onClick={() => openNewWindow(item.url)}>
                <Link />
                {/* <img src={link} /> */}
              </button>
            </div>
            <div className="viewdata-copy">
              <button onClick={() => copyToClipboard(item.url)}>
                <LinkCopy />
              </button>
            </div>
            {/* </label> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ViewMode;
